import React, { Component, Fragment } from 'react';
import { Breadcrumbs, Modal, Paper, Typography, withStyles } from '@material-ui/core';
import MaterialTable from 'material-table';
import { Query, withApollo } from "react-apollo";
// import { gerenciarSalasListQuery, gerenciarSalasArquivarMutation, gerenciarSalasRestaurarMutation } from '../../graphql/Salas';
import { gerenciarGruposLocaisListQuery, gerenciarGruposLocaisArquivarMutation, gerenciarGruposLocaisRestaurarMutation } from '../../graphql/GrupoLocal'
import autoBind from 'react-autobind';
import { Button, Row, Col, ButtonToolbar, Form } from 'react-bootstrap';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import RemoveRedEyeOutlinedIcon from '@material-ui/icons/RemoveRedEyeOutlined';
import UndoOutlinedIcon from '@material-ui/icons/UndoOutlined';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import GrupoLocalWidgetForm from '../../widgets/definicoes/grupo-local/GrupoLocalWidgetForm';
import MaterialTableUtils from '../../environment/materialTableUtils';
import Swal from 'sweetalert2';

const { Group } = Form;

const styles = theme => ({
    button: {
        margin: theme.spacing(1),
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
    root: {
        padding: theme.spacing(3, 2),
        minHeight: 470
    },
});

class AdmGrupoLocal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            verArquivados: false,
            showModal: false,
            id: null
        }

        autoBind(this);
    }

    handleShowModal(id, action) {
        this.setState({
            showModal: true,
            id: id || null,
            action
        });
    }

    handleModalClose() {
        this.setState({
            showModal: false,
            id: null
        });

        this.doRefetch();
    }

    doRefetch() {
        if (!this._queryRefetch)
            return;

        this.props.client.clearStore().then (
            () => this._queryRefetch(this._queryVariables ? { variables: this._queryVariables } : {})
        ) ;
    }

    render() {
        const {  id, showModal } = this.state;
        const { classes } = this.props;

        return (
            <Paper className={classes.root}>
                {this.renderBreadCrumb()}
                <Row>
                    <Col>
                        { this.renderBotoesSuperiores() }
                    </Col>
                </Row>
                {<Fragment>
                        {this.renderGridPrincipal()}
                 </Fragment>}
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={showModal}
                    onClose={this.handleClose}
                >
                    <div className={classes.paper}>
                        <Paper className={classes.root}>
                            <GrupoLocalWidgetForm id={id} action={this.state.action} handleModalClose={this.handleModalClose} />
                        </Paper>
                    </div>
                </Modal>
            </Paper >
        );
    }

    renderGridPrincipal() {
        this._queryVariables = {
            arquivado: this.state.verArquivados
        };

        const actions = this.geraActions();

        return (
            <Query query={gerenciarGruposLocaisListQuery} variables={{ ...this._queryVariables }} fetchPolicy='network-only'>
                {({ data, loading, error, refetch }) => {
                    if (loading) return 'Loading...'
                    if (error) return `Error! ${error.message}`
                    this._queryRefetch = refetch;

                    return (
                        <MaterialTable
                            actions={actions}
                            columns={[
                                {
                                    title: "Nome",
                                    field: "nome",
                                    defaultSort: "asc",
                                    customSort: MaterialTableUtils.getInsensitiveSortFunctionByAttribute('nome')
                                },
                                {
                                    title: "Usuários no grupo",
                                    field: "membros"
                                },
                            ]}
                            data={data.gruposLocaisList}
                            localization={{
                                body: {
                                    emptyDataSourceMessage: 'Nenhum grupo local encontrado'
                                },
                                header: {
                                    actions: 'Ações'
                                },
                                toolbar: {
                                    searchPlaceholder: 'Pesquisar',
                                    searchTooltip: 'Pesquisar'
                                }
                            }}
                            options={{
                                actionsColumnIndex: -1,
                                paging: false,
                                draggable: false,
                                sorting: true
                            }}
                            title={
                                this.state.verArquivados ? "Grupos Locais (arquivados)" : "Grupos"
                            }
                        />
                    );
                }}
            </Query>
        );
    }

    geraActions() {
        const actions = [];
        const somenteLeitura = false;

        // Botão de arquivar ou restaurar
        if (this.state.verArquivados) {
            actions.push({
                hidden: somenteLeitura,
                icon: UndoOutlinedIcon,
                tooltip: 'Restaurar',
                onClick: (event, rowData) => {
                    this.props.client.mutate({
                        mutation: gerenciarGruposLocaisRestaurarMutation,
                        variables: {
                            id: rowData.id
                        }
                    }).then(() => this.doRefetch());
                }
            });
        } else {
            actions.push({
                hidden: somenteLeitura,
                icon: DeleteOutlinedIcon,
                tooltip: 'Arquivar',
                onClick: (event, rowData) => {

                    if (rowData.membros > 0) {
                        Swal.fire({
                            title: "Erro",
                            text: "Não é possível arquivar um grupo local que tenha usuários a ele vinculados",
                            icon: "error",
                            confirmButtonColor: "#ff0000",
                            showCancelButton: false,
                        });
                        return;
                    }

                    this.props.client.mutate({
                        mutation: gerenciarGruposLocaisArquivarMutation,
                        variables: {
                            id: rowData.id
                        }
                    }).then(() => this.doRefetch());
                }
            });

            actions.push({
                hidden: somenteLeitura,
                icon: EditOutlinedIcon,
                tooltip: 'Editar',
                onClick: (event, rowData) => this.handleShowModal(rowData.id, 'edit')
            });

            actions.push({
                icon: RemoveRedEyeOutlinedIcon,
                tooltip: 'Ver',
                onClick: (event, rowData) => this.handleShowModal(rowData.id, 'view')
            });
        }

        return actions;
    }

    renderBotoesSuperiores() {
        const { classes } = this.props;
        return (
            <Group className="btn-bar">
                <ButtonToolbar>
                    <Button disabled={false} variant="primary" className={`${classes.button} btn-primary-get`} onClick={() => this.handleShowModal(null, 'new')}>
                        Novo Grupo
                    </Button>
                    {
                        this.state.verArquivados !== true
                            ? (
                                <Button variant="secondary" className={`${classes.button} btn-secondary-get`} onClick={() => this.setState({ verArquivados: true })} >
                                    Lixeira
                                </Button>
                            ) : (
                                <Button variant="secondary" className={`${classes.button} btn-secondary-get`} onClick={() => this.setState({ verArquivados: false })} >
                                    Sair da lixeira
                                </Button>
                            )
                    }
                </ButtonToolbar>
            </Group>
        );
    }


    renderBreadCrumb() {
        // const {  } = this.props;
        return (
            <Breadcrumbs aria-label="Breadcrumb" className="bradcrumbs">
                <Typography >Administrar</Typography>
                <div>Grupos Locais</div>
            </Breadcrumbs>
        );
    }
}

export default (withStyles(styles)(withApollo(AdmGrupoLocal)));